module.exports = __webpack_public_path__ + "img/platipus.56355a2f.svg";